import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function BlogPost1() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Fiber Optik Kablo Tamiri Nasıl Yapılır? Profesyonel Rehber | Fiber Ek';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Fiber optik kablo tamiri adım adım rehberi. Fusion splicing, OTDR testi, arıza tespiti ve profesyonel onarım yöntemleri. İstanbul, Kocaeli, Gebze, Tuzla\'da 7/24 acil fiber tamir hizmeti.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Fiber optik kablo tamiri adım adım rehberi. Fusion splicing, OTDR testi, arıza tespiti ve profesyonel onarım yöntemleri. İstanbul, Kocaeli, Gebze, Tuzla\'da 7/24 acil fiber tamir hizmeti.';
      document.head.appendChild(meta);
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Fiber Optik Kablo Tamiri Nasıl Yapılır? Profesyonel Rehber | Fiber Ek');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Fiber Optik Kablo Tamiri Nasıl Yapılır? Profesyonel Rehber | Fiber Ek';
      document.head.appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Fiber optik kablo tamiri adım adım rehberi. Fusion splicing, OTDR testi ve profesyonel onarım yöntemleri.');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Fiber optik kablo tamiri adım adım rehberi. Fusion splicing, OTDR testi ve profesyonel onarım yöntemleri.';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://fiberek.com/blog/fiber-optik-kablo-tamiri-nasil-yapilir');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://fiberek.com/blog/fiber-optik-kablo-tamiri-nasil-yapilir';
      document.head.appendChild(meta);
    }

    const ogType = document.querySelector('meta[property="og:type"]');
    if (ogType) {
      ogType.setAttribute('content', 'article');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:type');
      meta.content = 'article';
      document.head.appendChild(meta);
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://fiberek.com/blog/fiber-optik-kablo-tamiri-nasil-yapilir');
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = 'https://fiberek.com/blog/fiber-optik-kablo-tamiri-nasil-yapilir';
      document.head.appendChild(link);
    }

    // Article Schema
    const schemaId = 'blog-post-1-schema';
    if (!document.getElementById(schemaId)) {
      const script = document.createElement('script');
      script.id = schemaId;
      script.type = 'application/ld+json';
      script.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": "Fiber Optik Kablo Tamiri Nasıl Yapılır? Profesyonel Rehber",
        "description": "Fiber optik kablo tamiri adım adım rehberi. Fusion splicing, OTDR testi, arıza tespiti ve profesyonel onarım yöntemleri.",
        "url": "https://fiberek.com/blog/fiber-optik-kablo-tamiri-nasil-yapilir",
        "datePublished": "2024-05-15",
        "dateModified": "2025-07-10",
        "author": {
          "@type": "Organization",
          "name": "Fiber Ek",
          "url": "https://fiberek.com"
        },
        "publisher": {
          "@type": "Organization",
          "name": "Fiber Ek",
          "url": "https://fiberek.com"
        },
        "articleSection": "Fiber Optik",
        "keywords": "fiber optik kablo tamiri, fusion splicing, OTDR testi, fiber arıza, fiber ek",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://fiberek.com/" },
            { "@type": "ListItem", "position": 2, "name": "Blog", "item": "https://fiberek.com/blog" },
            { "@type": "ListItem", "position": 3, "name": "Fiber Optik Kablo Tamiri Nasıl Yapılır?", "item": "https://fiberek.com/blog/fiber-optik-kablo-tamiri-nasil-yapilir" }
          ]
        }
      });
      document.head.appendChild(script);
    }

    return () => {
      document.title = 'Fiber Ek';
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative pt-32 pb-12 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <Link to="/blog" className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 mb-6 transition-colors">
              <i className="ri-arrow-left-line"></i>
              <span className="font-medium">Blog'a Dön</span>
            </Link>
            
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Fiber Optik Kablo Tamiri Nasıl Yapılır? Profesyonel Rehber
            </h1>
            
            <div className="flex flex-wrap items-center gap-4 text-slate-300">
              <div className="flex items-center gap-4 text-sm">
                <div className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  <span>15 Mayıs 2024</span>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  <span>8 dakika okuma</span>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-folder-line"></i>
                  <span>Fiber Optik</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="py-12 bg-slate-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/b89708141c3b145fce5b658fd5766c1f.jpg"
                alt="Fiber Optik Kablo Tamiri"
                className="w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              
              <p className="text-xl text-slate-700 leading-relaxed mb-8 font-medium">
                Fiber optik kablo tamiri, günümüzün yüksek hızlı internet ve veri iletişim altyapısının kesintisiz çalışması için kritik öneme sahiptir. İstanbul, Kocaeli, Gebze, Tuzla ve çevre illerdeki sanayi bölgelerinde fiber optik arızalar, işletmelerin operasyonlarını ciddi şekilde etkileyebilir.
              </p>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Fiber Optik Kablo Arızaları Neden Oluşur?</h2>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Fiber optik kablolarda arıza oluşumunun birçok farklı nedeni bulunmaktadır. En yaygın arıza sebepleri şunlardır:
              </p>

              <div className="bg-slate-50 border-l-4 border-teal-500 p-6 rounded-r-xl mb-8">
                <ul className="space-y-3 text-slate-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Fiziksel Hasar:</strong> İnşaat, kazı veya yol çalışmaları sırasında kablonun yanlışlıkla kesilmesi veya ezilmesi</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Çevresel Faktörler:</strong> Aşırı sıcaklık değişimleri, nem, su sızıntısı veya donma olayları</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Yanlış Kurulum:</strong> Kablonun aşırı bükülmesi, gerilmesi veya hatalı sonlandırma işlemleri</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Kemirgen Hasarı:</strong> Fareler ve diğer kemirgenlerin kablo kılıflarını kemirmesi</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Yaşlanma:</strong> Kablo malzemelerinin zamanla aşınması ve performans kaybı</span>
                  </li>
                </ul>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Fiber Optik Kablo Tamiri Adım Adım</h2>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">1. Arıza Tespiti ve OTDR Testi</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Fiber optik kablo tamirinin ilk ve en önemli adımı, arızanın tam konumunun belirlenmesidir. Bu aşamada <Link to="/fiber-hizmetleri/otdr-test" className="text-teal-600 hover:text-teal-700 font-semibold">OTDR (Optical Time Domain Reflectometer) test cihazı</Link> kullanılır. OTDR testi sayesinde:
              </p>

              <ul className="space-y-3 text-slate-700 mb-6 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Arızanın fiber hattı üzerindeki tam konumu metre cinsinden belirlenir</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Sinyal kaybının miktarı (dB cinsinden) ölçülür</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Kablo üzerindeki tüm ek noktaları ve kayıplar tespit edilir</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Fiber kalitesi ve performansı analiz edilir</span>
                </li>
              </ul>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">2. Arıza Noktasına Erişim</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                OTDR testi ile arıza noktası belirlendikten sonra, fiziksel erişim sağlanır. Bu aşamada:
              </p>

              <ul className="space-y-3 text-slate-700 mb-6 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Yeraltı kablolar için kazı çalışması yapılır</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Bina içi kablolar için kablo kanalları açılır</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Hasar görmüş kablo bölümü ortaya çıkarılır</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Çalışma alanı temizlenir ve güvenlik önlemleri alınır</span>
                </li>
              </ul>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">3. Fiber Hazırlık İşlemleri</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Fusion splicing (kaynaklı ek) işlemi için fiber uçlarının hassas bir şekilde hazırlanması gerekir:
              </p>

              <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-8 rounded-2xl mb-8 border border-teal-100">
                <h4 className="text-xl font-bold text-slate-900 mb-4">Fiber Hazırlık Adımları:</h4>
                <ol className="space-y-4 text-slate-700">
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">1</span>
                    <div>
                      <strong className="block mb-1">Kablo Soyma:</strong>
                      <span>Dış kılıf ve koruyucu katmanlar özel soyma aletleri ile dikkatlice çıkarılır</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">2</span>
                    <div>
                      <strong className="block mb-1">Fiber Temizliği:</strong>
                      <span>İzopropil alkol ve lint-free mendiller ile fiber yüzeyi temizlenir</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">3</span>
                    <div>
                      <strong className="block mb-1">Fiber Kesme:</strong>
                      <span>Precision cleaver (hassas kesici) ile fiber ucu 90 derece açıyla kesilir</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">4</span>
                    <div>
                      <strong className="block mb-1">Kalite Kontrolü:</strong>
                      <span>Mikroskop altında fiber uç yüzeyi incelenir ve kusursuz olduğu doğrulanır</span>
                    </div>
                  </li>
                </ol>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">4. Fusion Splicing (Kaynaklı Ek) İşlemi</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                <Link to="/fiber-hizmetleri/fiber-sonlandirma" className="text-teal-600 hover:text-teal-700 font-semibold">Fusion splicing</Link>, fiber optik kabloların en kaliteli birleştirme yöntemidir. Bu işlemde:
              </p>

              <ul className="space-y-3 text-slate-700 mb-6 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>İki fiber ucu fusion splicer cihazına yerleştirilir</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Cihaz otomatik olarak fiberleri hizalar (core alignment)</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Elektrik arkı ile fiberler 2000°C sıcaklıkta kaynaştırılır</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Ek kaybı cihaz tarafından otomatik ölçülür (tipik olarak 0.02-0.05 dB)</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Ek noktası heat shrink sleeve (ısıyla daralan kılıf) ile korunur</span>
                </li>
              </ul>

              <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-r-xl mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-alert-line text-amber-600 text-2xl mt-1"></i>
                  <div>
                    <h4 className="font-bold text-amber-900 mb-2">Önemli Not:</h4>
                    <p className="text-amber-800 leading-relaxed">
                      Fusion splicing işlemi son derece hassas bir işlemdir ve profesyonel ekipman ile deneyimli teknisyenler tarafından yapılmalıdır. Hatalı ek işlemi, yüksek sinyal kaybına ve bağlantı sorunlarına neden olabilir.
                    </p>
                  </div>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">5. Ek Koruma ve Splice Closure Montajı</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Kaynaklı ek tamamlandıktan sonra, ek noktasının çevresel faktörlere karşı korunması gerekir:
              </p>

              <ul className="space-y-3 text-slate-700 mb-6 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Fiber ekler splice tray (ek tepsisi) içine düzenli şekilde yerleştirilir</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Splice closure (ek kutusu) su geçirmez şekilde kapatılır</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Yeraltı uygulamalarda ek kutusu uygun derinliğe gömülür</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Bina içi uygulamalarda duvar tipi ek kutuları kullanılır</span>
                </li>
              </ul>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">6. Test ve Doğrulama</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Tamir işlemi tamamlandıktan sonra, sistemin tam performansla çalıştığından emin olmak için kapsamlı testler yapılır:
              </p>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-line-chart-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">OTDR Test</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Tamir sonrası OTDR testi ile ek kalitesi, toplam kayıp ve fiber performansı doğrulanır
                  </p>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-flashlight-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Işık Kaybı Testi</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Power meter ve light source ile toplam ışık kaybı ölçülür (insertion loss)
                  </p>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-eye-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Görsel Muayene</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Fiber mikroskop ile ek noktası ve konnektörler görsel olarak incelenir
                  </p>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-speed-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Performans Testi</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Veri iletim hızı ve bant genişliği testleri ile sistem performansı doğrulanır
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Fiber Optik Kablo Türleri ve Tamir Özellikleri</h2>

              <p className="text-slate-700 leading-relaxed mb-6">
                Farklı fiber optik kablo türleri, tamir süreçlerinde farklı yaklaşımlar gerektirir:
              </p>

              <div className="space-y-6 mb-8">
                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <h4 className="font-bold text-slate-900 mb-3 flex items-center gap-2">
                    <span className="w-8 h-8 bg-teal-500 text-white rounded-lg flex items-center justify-center text-sm">SM</span>
                    Single Mode (Tek Modlu) Fiber
                  </h4>
                  <p className="text-slate-700 text-sm leading-relaxed mb-3">
                    Uzun mesafe iletişim için kullanılır (10-100 km). 9/125 µm çekirdek/kılıf çapına sahiptir. Metro ethernet, şehirlerarası bağlantılar ve telekom uygulamalarında tercih edilir.
                  </p>
                  <p className="text-slate-600 text-sm">
                    <strong>Tamir Özellikleri:</strong> Daha hassas hizalama gerektirir, fusion splicing zorunludur, tipik ek kaybı 0.02-0.05 dB
                  </p>
                </div>

                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <h4 className="font-bold text-slate-900 mb-3 flex items-center gap-2">
                    <span className="w-8 h-8 bg-teal-500 text-white rounded-lg flex items-center justify-center text-sm">MM</span>
                    Multi Mode (Çok Modlu) Fiber - OM3/OM4
                  </h4>
                  <p className="text-slate-700 text-sm leading-relaxed mb-3">
                    Kısa mesafe uygulamalar için kullanılır (300-550 m). 50/125 µm veya 62.5/125 µm çekirdek/kılıf çapına sahiptir. Bina içi network, veri merkezi ve kampüs ağlarında yaygındır.
                  </p>
                  <p className="text-slate-600 text-sm">
                    <strong>Tamir Özellikleri:</strong> Daha toleranslı hizalama, hem fusion hem mechanical splicing kullanılabilir, tipik ek kaybı 0.05-0.15 dB
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Acil Fiber Optik Tamir Hizmeti</h2>

              <p className="text-slate-700 leading-relaxed mb-6">
                İşletmenizde fiber optik kablo arızası yaşandığında, hızlı müdahale kritik önem taşır. <Link to="/fiber-hizmetleri/acil-servis" className="text-teal-600 hover:text-teal-700 font-semibold">7/24 acil fiber tamir hizmetimiz</Link> ile:
              </p>

              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4 text-3xl font-bold">
                    &lt;2
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Hızlı Müdahale</h4>
                  <p className="text-slate-600 text-sm">
                    İstanbul ve çevre illerde 2 saat içinde yerinde
                  </p>
                </div>

                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-24-hours-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">7/24 Destek</h4>
                  <p className="text-slate-600 text-sm">
                    Hafta sonu ve tatil günleri dahil kesintisiz hizmet
                  </p>
                </div>

                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-tools-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Profesyonel Ekip</h4>
                  <p className="text-slate-600 text-sm">
                    10+ yıl deneyimli sertifikalı teknisyenler ve son teknoloji ekipman
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Hizmet Verdiğimiz Bölgeler</h2>

              <p className="text-slate-700 leading-relaxed mb-6">
                Fiber optik kablo tamiri hizmetlerimiz, İstanbul ve çevre illerdeki tüm sanayi bölgelerini kapsamaktadır:
              </p>

              <div className="grid md:grid-cols-2 gap-4 mb-8">
                <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                  <i className="ri-map-pin-line text-teal-500 text-xl"></i>
                  <span className="text-slate-700"><Link to="/bolgeler/istanbul-avrupa" className="hover:text-teal-600 font-medium">İstanbul Avrupa Yakası</Link> - Tüm ilçeler</span>
                </div>
                <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                  <i className="ri-map-pin-line text-teal-500 text-xl"></i>
                  <span className="text-slate-700"><Link to="/bolgeler/istanbul-anadolu" className="hover:text-teal-600 font-medium">İstanbul Anadolu Yakası</Link> - Tüm ilçeler</span>
                </div>
                <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                  <i className="ri-map-pin-line text-teal-500 text-xl"></i>
                  <span className="text-slate-700"><Link to="/bolgeler/gebze" className="hover:text-teal-600 font-medium">Gebze</Link> - GOSB, Plastikçiler OSB</span>
                </div>
                <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                  <i className="ri-map-pin-line text-teal-500 text-xl"></i>
                  <span className="text-slate-700"><Link to="/bolgeler/tuzla" className="hover:text-teal-600 font-medium">Tuzla</Link> - OSB, Kimya OSB, Deri OSB</span>
                </div>
                <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                  <i className="ri-map-pin-line text-teal-500 text-xl"></i>
                  <span className="text-slate-700"><Link to="/bolgeler/kocaeli" className="hover:text-teal-600 font-medium">Kocaeli</Link> - Tüm OSB'ler</span>
                </div>
                <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                  <i className="ri-map-pin-line text-teal-500 text-xl"></i>
                  <span className="text-slate-700"><Link to="/bolgeler/bursa" className="hover:text-teal-600 font-medium">Bursa</Link> - Sanayi bölgeleri</span>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Sık Sorulan Sorular</h2>

              <div className="space-y-4 mb-12">
                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Fiber optik kablo tamiri ne kadar sürer?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Tamir süresi arızanın türüne ve konumuna bağlıdır. Basit bir ek işlemi 2-3 saat sürerken, yeraltı kablo tamiri kazı işlemleri nedeniyle 4-8 saat alabilir. Acil durumlarda ekibimiz 2 saat içinde yerinde olup, en kısa sürede sistemi devreye alır.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Fiber optik kablo tamiri maliyeti nedir?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Tamir maliyeti, arıza türü, kablo tipi, erişim zorluğu ve gerekli malzemelere göre değişir. Ücretsiz keşif hizmetimiz ile yerinde inceleme yapıp, detaylı fiyat teklifi sunuyoruz. Acil müdahale hizmetlerimiz 7/24 aktiftir.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Fusion splicing mi yoksa mechanical splicing mi daha iyidir?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Fusion splicing (kaynaklı ek) daha kaliteli ve kalıcı bir çözümdür. Ek kaybı çok düşüktür (0.02-0.05 dB) ve uzun ömürlüdür. Mechanical splicing ise geçici çözümler için kullanılabilir ancak daha yüksek kayıp değerleri (0.1-0.5 dB) ve mekanik hassasiyet sorunları nedeniyle kalıcı uygulamalarda tercih edilmez.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Fiber optik kablo tamiri sonrası garanti var mı?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Evet, tüm fiber optik tamir işlemlerimiz için 2 yıl garanti veriyoruz. Tamir sonrası OTDR test raporları ile ek kalitesi belgelenir. Garanti kapsamında herhangi bir sorun yaşanması durumunda ücretsiz müdahale sağlanır.
                  </p>
                </details>
              </div>

            </div>

            {/* CTA Section */}
            <div className="mt-16 p-8 bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl text-center">
              <h3 className="text-3xl font-bold text-white mb-4">
                Fiber Optik Arıza mı Yaşıyorsunuz?
              </h3>
              <p className="text-slate-300 text-lg mb-6">
                7/24 acil müdahale ekibimiz 2 saat içinde yerinde!
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <a
                  href="tel:+905537165561"
                  className="px-8 py-4 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-teal-500/50 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line mr-2"></i>
                  +90 553 716 55 61
                </a>
                <a
                  href="https://wa.me/905537165561"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-white hover:bg-slate-50 text-slate-900 font-semibold rounded-xl transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  WhatsApp Destek
                </a>
              </div>
            </div>

            {/* İlgili Hizmetler */}
            <div className="mt-12">
              <h3 className="text-2xl font-bold text-slate-900 mb-6">İlgili Hizmetlerimiz</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <Link to="/fiber-hizmetleri/fiber-kablo-tamiri" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-tools-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">Fiber Kablo Tamiri</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Profesyonel fiber optik onarım hizmeti</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/fiber-hizmetleri/acil-servis" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-alarm-warning-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">7/24 Acil Fiber Servisi</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">2 saat içinde yerinde müdahale</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/fiber-hizmetleri/otdr-test" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-line-chart-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">OTDR Test Hizmeti</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Arıza tespiti ve fiber analizi</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/fiber-hizmetleri/fiber-sonlandirma" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-flashlight-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">Fusion Splicing & Sonlandırma</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Profesyonel fiber ek ve konnektör işlemleri</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
              </div>
            </div>

            {/* Related Articles */}
            <div className="mt-16">
              <h3 className="text-2xl font-bold text-slate-900 mb-6">İlgili Makaleler</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <Link to="/blog/otdr-testi-nedir" className="group">
                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-teal-500 transition-all hover:shadow-lg">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors">
                      <i className="ri-line-chart-line text-2xl text-teal-600 group-hover:text-white"></i>
                    </div>
                    <h4 className="font-bold text-slate-900 mb-2 group-hover:text-teal-600">OTDR Testi Nedir?</h4>
                    <p className="text-slate-600 text-sm">Fiber optik arıza tespitinde kullanılan OTDR test yöntemi</p>
                  </div>
                </Link>

                <Link to="/blog/fusion-splicing-nedir" className="group">
                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-teal-500 transition-all hover:shadow-lg">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors">
                      <i className="ri-flashlight-line text-2xl text-teal-600 group-hover:text-white"></i>
                    </div>
                    <h4 className="font-bold text-slate-900 mb-2 group-hover:text-teal-600">Fusion Splicing Nedir?</h4>
                    <p className="text-slate-600 text-sm">Fiber optik kaynaklı ek teknolojisi ve uygulama yöntemleri</p>
                  </div>
                </Link>

                <Link to="/blog/fabrikalarda-fiber-altyapi-rehberi" className="group">
                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-teal-500 transition-all hover:shadow-lg">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors">
                      <i className="ri-building-line text-2xl text-teal-600 group-hover:text-white"></i>
                    </div>
                    <h4 className="font-bold text-slate-900 mb-2 group-hover:text-teal-600">Fabrika Fiber Altyapı</h4>
                    <p className="text-slate-600 text-sm">Endüstriyel tesislerde fiber optik altyapı kurulumu</p>
                  </div>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
}